import { render, staticRenderFns } from "./FoodServiceTab.vue?vue&type=template&id=54856446&scoped=true"
import script from "./FoodServiceTab.vue?vue&type=script&lang=js"
export * from "./FoodServiceTab.vue?vue&type=script&lang=js"
import style0 from "./FoodServiceTab.vue?vue&type=style&index=0&id=54856446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54856446",
  null
  
)

export default component.exports